'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropdown = require('dropdown');

var _availabilityCalendar = require('availability-calendar');

var _doctifyGoogleMap = require('../../../doctify-google-map');

var _bookAppointmentSection = require('../../src/styles/book-appointment-section.scss');

var _bookAppointmentSection2 = _interopRequireDefault(_bookAppointmentSection);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookAppointmentSection = function BookAppointmentSection(props) {
	var practices = props.practices;

	var practicesWithoutNhs = void 0;

	practicesWithoutNhs = practices && practices.filter(function (practice) {
		return practice && practice.id && !practice.isNhs;
	}) || [];
	return _react2.default.createElement(
		'div',
		null,
		practicesWithoutNhs.length > 0 && _react2.default.createElement(
			'div',
			{ id: _bookAppointmentSection2.default.bookAppointmentSection, className: props.className },
			_react2.default.createElement(
				'div',
				{ className: _bookAppointmentSection2.default.header },
				_react2.default.createElement(
					'span',
					{ className: _bookAppointmentSection2.default.title },
					'Book appointment'
				),
				' ',
				_react2.default.createElement(
					'span',
					{ className: _bookAppointmentSection2.default.pink },
					' - in less than 60 seconds'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _bookAppointmentSection2.default.viewToggle },
				_react2.default.createElement(
					'button',
					{ className: props.activeView === 'calendar' ? _bookAppointmentSection2.default.active : '', onClick: function onClick() {
							return props.toggleView('calendar');
						} },
					'Calendar'
				),
				_react2.default.createElement(
					'button',
					{ className: props.activeView === 'map' ? _bookAppointmentSection2.default.active : '', onClick: function onClick() {
							return props.toggleView('map');
						} },
					'Map'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _bookAppointmentSection2.default.dropdownContainer },
				_react2.default.createElement(_dropdown.Dropdown, {
					id: _bookAppointmentSection2.default.practiceDropdown,
					items: practicesWithoutNhs,
					readonly: true,
					placeholder: 'No practices available',
					selectedItem: practicesWithoutNhs.length && (props.selectedPractice || practicesWithoutNhs[0]),
					onItemSelected: props.onPracticeSelected })
			),
			props.activeView === 'calendar' && _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ className: _bookAppointmentSection2.default.calendarContainer },
					_react2.default.createElement(_availabilityCalendar.AvailabilityCalendar, {
						startDate: props.startDate,
						isLoadingAvailabilities: props.isLoadingAvailabilities,
						availabilities: props.availabilities,
						nearestAvailability: props.nearestAvailability,
						hasRequestAppointment: props.hasRequestAppointment && props.isCore,
						onPreviousButtonClick: props.onPreviousButtonClick,
						onNextButtonClick: props.onNextButtonClick,
						onSlotClick: props.onSlotClick,
						onNearestAvailabilityClick: props.onNearestAvailabilityClick,
						onRequestAppointmentClick: props.onRequestAppointmentClick,
						onBmiRequestAppointmentClick: props.onBmiRequestAppointmentClick,
						className: props.calendarStyles,
						columnStyles: props.calendarColumnStyles,
						mobileStyles: props.calendarMobileStyles,
						tabletStyles: props.calendarTabletStyles,
						laptopStyles: props.calendarLaptopStyles,
						requestBmiAppointmentOnSlotClick: true
					})
				),
				_react2.default.createElement(
					'div',
					{ className: _bookAppointmentSection2.default.footer },
					props.hasRequestAppointment && _react2.default.createElement(
						'p',
						null,
						_react2.default.createElement('i', { className: 'ion-ios-email-outline' }),
						'Can\'t find the time you are looking for? Please ',
						_react2.default.createElement(
							'a',
							{ onClick: props.onRequestAppointmentClick },
							'request appointment'
						),
						' - our doctors will always do their best to accomodate your needs.'
					)
				)
			),
			props.activeView === 'map' && (props.selectedPractice.location || !props.selectedPractice.id) && _react2.default.createElement(
				'div',
				{ className: _bookAppointmentSection2.default.mapContainer },
				_react2.default.createElement(_doctifyGoogleMap.DoctifyGoogleMap, {
					showAllMarkers: !props.selectedPractice.id,
					markers: practices.filter(function (practice) {
						return practice && practice.id && practice.location;
					}).map(function (practice) {
						return {
							position: {
								lat: practice.location.lat,
								lng: practice.location.lng
							}
						};
					}),
					iconUrl: (0, _doctifyUtils.getResourcePath)('/static/img/map-icons/practice.png'),
					defaultCenter: practices.length > 1 && practices[1].position,
					center: !props.selectedPractice.id ? null : {
						lat: props.selectedPractice.location.lat,
						lng: props.selectedPractice.location.lng
					},
					containerElementStyle: { height: '300px' } })
			),
			props.activeView === 'map' && !props.selectedPractice.location && !!props.selectedPractice.id && _react2.default.createElement(
				'h3',
				null,
				'Apologies! We could not locate this practice on Google Maps.'
			)
		)
	);
};
// import messages from '../lang/default-messages';

// import PropTypes from 'prop-types';
// import { FormattedMessage } from 'react-intl';

BookAppointmentSection.propTypes = {
	activeView: require('react').PropTypes.any.isRequired,
	toggleView: require('react').PropTypes.func.isRequired,
	practices: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
	selectedPractice: require('react').PropTypes.object.isRequired,
	onPracticeSelected: require('react').PropTypes.func.isRequired,
	startDate: require('react').PropTypes.object.isRequired,
	availabilities: require('react').PropTypes.arrayOf(require('react').PropTypes.any).isRequired,
	nearestAvailability: require('react').PropTypes.object.isRequired,
	hasRequestAppointment: require('react').PropTypes.bool.isRequired,
	isLoadingAvailabilities: require('react').PropTypes.bool.isRequired,
	onPreviousButtonClick: require('react').PropTypes.func.isRequired,
	onNextButtonClick: require('react').PropTypes.func.isRequired,
	onSlotClick: require('react').PropTypes.func.isRequired,
	onNearestAvailabilityClick: require('react').PropTypes.func.isRequired,
	onRequestAppointmentClick: require('react').PropTypes.func.isRequired,
	className: require('react').PropTypes.any.isRequired,
	calendarStyles: require('react').PropTypes.any.isRequired,
	calendarColumnStyles: require('react').PropTypes.any.isRequired,
	calendarMobileStyles: require('react').PropTypes.any.isRequired,
	calendarTabletStyles: require('react').PropTypes.any.isRequired,
	calendarLaptopStyles: require('react').PropTypes.any.isRequired
};


BookAppointmentSection.defaultProps = {
	activeView: 'calendar',
	hasRequestAppointment: false
};

exports.default = BookAppointmentSection;


// WEBPACK FOOTER //
// ./components/book-appointment-section/lib/components/book-appointment-section.js